import React, { Suspense } from 'react';

const PdfRender = React.lazy(() => import('./pdf-render'));

interface IProps {
    file: string,
    width?: number,
}
export const PdfView = (props:IProps) => (
  <div>
    <Suspense fallback={<div>Завантаження...</div>}>
      <PdfRender {...props} />
    </Suspense>
  </div>
);


